import React from 'react';
import { classes } from 'typestyle';
import Checkbox from '../../layout/checkbox/checkbox.component';
import {
    taxonomyListClassName,
    taxonomyListListClassName,
    taxonomyListListItemClassName,
    taxonomyListCheckboxContainerNameClassName,
    taxonomyListNameClassName,
    taxonomyListNameClickableClassName,
    taxonomyListSectionClassName,
    taxonomyListNameStrikethroughClassName
} from './taxonomy-list-filter.style';
import { TaxonomyListProps } from './taxonomy-list-filter.types';

const TaxonomyList: React.FC<TaxonomyListProps> = ({
    list,
    selectedIds,
    onChange,
    children,
    className,
    strikethroughIds,
}) => {
    return (
        <div className={ classes(taxonomyListClassName, className) }>
            { children && (
                <div className={ taxonomyListSectionClassName }>
                    { children }
                </div>
            ) }
            <ul data-list className={ taxonomyListListClassName }>
                { list.map((taxonomyData, index) => (
                    <li key={ index } className={ taxonomyListListItemClassName }>
                        { selectedIds && (
                            <div className={ taxonomyListCheckboxContainerNameClassName }>
                                <Checkbox
                                    value={ selectedIds.indexOf(taxonomyData.id) !== -1 }
                                    onChange={ newValue => onChange && onChange(
                                        newValue ? [...selectedIds, taxonomyData.id] : selectedIds.filter(id => id !== taxonomyData.id)
                                    ) }/>
                            </div>
                        ) }
                        <div className={ taxonomyListNameClassName }>
                            <span className={ classes(
                                taxonomyListNameClickableClassName,
                                (strikethroughIds && !!strikethroughIds.length)
                                && (strikethroughIds.includes(taxonomyData.id))
                                && (
                                    taxonomyListNameStrikethroughClassName
                                )
                            ) } onClick={ event => {
                                event.preventDefault();

                                if (selectedIds && onChange) {
                                    const newValue = !(selectedIds.indexOf(taxonomyData.id) !== -1);

                                    onChange(
                                        newValue
                                        ? [...selectedIds, taxonomyData.id]
                                        : selectedIds.filter(id => id !== taxonomyData.id)
                                    );
                                }
                            } }>
                                { taxonomyData.name }
                            </span>
                        </div>
                    </li>
                )) }
            </ul>
        </div>
    )
};

export default TaxonomyList;
